import { CharacterCount } from '@tiptap/extension-character-count'
import { FocusClasses as Focus } from '@tiptap/extension-focus'
import Placeholder from '@tiptap/extension-placeholder'
import { TextAlign } from '@tiptap/extension-text-align'
import { Underline } from '@tiptap/extension-underline'
import Youtube from '@tiptap/extension-youtube'

import StarterKit from '@tiptap/starter-kit'

import { YoutubeVideoChooser } from '#app/routes/admin+/blog+/posts+/editor/extensions/youtube-video'
import BlockquoteFigure from './bloquote-figure'
import Column from './columns/column'
import Columns from './columns/columns'
import Document from './document'
import Figcaption from './figcaption'
import Heading from './heading'
import HorizontalRule from './horizontal-rule'
import ImageBlock from './image-block'
import ImageUpload from './image-upload'
import Link from './link'
import SlashCommand from './slash-command/slash-command'

export const ExtensionKit = [
	Document,
	StarterKit.configure({
		document: false,
		dropcursor: false,
		heading: false,
		horizontalRule: false,
		blockquote: false,
		codeBlock: false,
	}),
	HorizontalRule,
	Columns,
	Column,
	Link.configure({
		openOnClick: false,
	}),
	ImageBlock,
	ImageUpload,
	Focus,
	SlashCommand,
	Underline,
	CharacterCount.configure({ limit: 50000 }),
	TextAlign.extend({
		addKeyboardShortcuts() {
			return {}
		},
	}).configure({
		types: ['heading', 'paragraph'],
	}),
	Figcaption,
	BlockquoteFigure,
	Heading,
	Placeholder,
	YoutubeVideoChooser,
	Youtube.configure({
		controls: true,
		nocookie: true,
		interfaceLanguage: 'en',
		modestBranding: true,
	}),
]

export {
	Column,
	Columns,
	Document,
	Heading,
	HorizontalRule,
	Link,
	SlashCommand,
}
